import FinishedScreen from './scenes/FinishedScreen';
import GameScreen from './scenes/GameScreen';
import TitleScreen from './scenes/TitleScreen';

export default {
  /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
  scenes: [TitleScreen, GameScreen, FinishedScreen],

  /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
  startScene: TitleScreen.KEY,

  shouldShowHelp: true,
  userImage: null, // store the one they just made
  /** @type {Phaser.Textures.CanvasTexture[]} */
  picCollection: [], // store resized versions of each one they made [darn sauce is spoiling storing a serialized ice cream]
  sundayInfo: null,
  containerDishName: ''
};
